<div 
     class="modal fade show custom_popup custom_popup_responsive justify-content-center"
     tabindex="-1"
     role="dialog"
>
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header justify-content-between">
                <h5 class="modal-title">
                    Make Withdrawal
                </h5>
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        (click)="closeModal()"
                >
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body padding-model form-editing">
              
<div class="row">
    <div class="col-lg-12">
        <div class="card w-100">
            <div class="card">
                <form
                    *ngIf="WithdrawFundForm"
                    [formGroup]="WithdrawFundForm"
                    (ngSubmit)="onSubmit()"
                >
                    <div class="row">

                        <div style="width: 200px;" class="field-groups">
                            <div class="mt-3">
                                <label for="investorId" class="form-title">
                                    <span class="required">*</span> Investor
                                </label>
                                <ng-select class="custom"
                                           id="investorId"
                                           [style.flex]="1"
                                           [items]="investors"
                                           bindLabel="name"
                                           bindValue="id"
                                           placeholder="All"
                                           formControlName="investorId"
                                           (change)="onSelect($event)"
                                           >
                                           <ng-template ng-option-tmp let-item="item">
                                            <span [title]="item.name">{{ item.name }}</span>
                                          </ng-template>
                                </ng-select>
                            </div>
                          <app-form-error-component [control]="WithdrawFundForm.controls['investorId']" />
                        </div>

                        <div style="width: 65px;"  class="field-groups custom-margin-1 align-items-center daterange_sec select_bank_filter">
                            <div class="mt-3">
                                <label for="type" class="form-title text-nowrap"><span class="required">*</span> Type</label>
                                <select
                                    class="custom-form-select border-radius-100"
                                    id="type"
                                    formControlName="type"
                                >
                                    <option *ngFor="let tt of type" [value]="tt.id">
                                        {{ tt.name }}
                                    </option>
                                </select>
                            </div>
                          <app-form-error-component [control]="WithdrawFundForm.controls['type']" />
                        </div>
                      
                        <div style="width: 57px;" class="field-groups">
                            <div class="mt-3">
                                <label for="ccy" class="form-title text-nowrap"
                                ><span class="required">*</span> Ccy</label>
                                <select
                                    class="custom-form-select border-radius-100"
                                    id="ccy"
                                    formControlName="ccy"
                                >
                                <option *ngFor="let ccy of allCcyData" [value]="ccy.id">
                                    {{ ccy.name }}
                                </option>
                                </select>
                            </div>
                          <app-form-error-component [control]="WithdrawFundForm.controls['ccy']" />
                        </div>

                        <div style="width: 86px;" class="field-groups">
                            <div class="mt-3">
                                <label for="faceValue" class="form-title"
                                ><span class="required">*</span> Amount
</label>
                                <input
                                    id="faceValue"
                                    [appOnlyNumber]="true"
                                    type="text"
                                    class="form-control ft-width numberText"
                                    placeholder=""
                                    formControlName="faceValue"
                                    maxlength="12"
                                    (focus)="handleFocusFaceValue()"
                                    (focusout)="handleFocusOutFaceValue()"
                                />
                            </div>
                          <app-form-error-component [control]="WithdrawFundForm.controls['faceValue']" />
                        </div>

                        
                        <div style="width: 77px;" class="field-groups">
                            <div class="mt-3">
                                <label for="product" class="form-title text-nowrap"
                                ><span class="required">*</span> Product</label>
                                <select  *ngIf="!investorId"
                                    class="custom-form-select border-radius-100"
                                    id="product"
                                    formControlName="product"
                                >
                                    <option *ngFor="let prod of product" [value]="prod.id" >
                                        {{ prod.name }}
                                    </option>
                                </select>

                                <input
                                *ngIf="investorId"
                                id="product"
                                type="text"
                                class="form-control ft-width "
                                placeholder=""
                                formControlName="product"
                                [readOnly]="true"
                            />

                            </div>
                          <app-form-error-component [control]="WithdrawFundForm.controls['product']" />
                        </div>

                        <div style="width: 135px;" class="field-groups">
                            <div class="mt-3">
                                <label for="date" class="form-title"><span class="required">*</span> Date
                                </label>
                                <div class="input-group">
                                  <app-date-picker id="date" formControlName="date" />
                                  <app-form-error-component [control]="WithdrawFundForm.controls['date']" />
                                </div>
                            </div> 
                        </div>

                        <div class="field-groups width-110">
                            <div class="mt-3">
                                <label for="fullRedemption" class="form-title">
                                    Full Redemption
                                </label>
                                <div>
                                    <input
                                        type="checkbox"
                                        id="fullRedemption"
                                        formControlName="fullRedemption"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="field-groups width-85">
                            <div class="mt-3">
                                <label for="currentBalance" class="form-title">
                                    Balance
                                </label>
                                <div class="ft-width">{{ currentBalance | number:'1.2-2' }}</div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="mt-3">  
                            {{noteText}} {{iban}}
                            </div>
                        </div>
                        <div class="col-12 bottom-fixed">
                            <hr />
                            <div class="d-flex justify-content-center mt-3">
                                <button [disabled]="WithdrawFundForm.invalid" type="submit" class="btn btn-light me-3 btn-custom-footer save_btn">
                                    Save
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-light btn-custom-footer cancel_btn"
                                    data-dismiss="modal"
                                    (click)="closeModal()"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
            </div>
        </div>
    </div>
</div>
